export const getGroupHierarchyIds = (group) =>
  group?.hierarchyIds
    ? [...group.hierarchyIds]
    : [...(group?.parentIds || []), group?.id].filter(Boolean);

export const getNearestDemandRollupTargetId = ({
  group,
  groupLookup = {},
  groupTypes = {},
  includeSelf = true,
}) =>
  getGroupHierarchyIds(group)
    .filter((groupId) => includeSelf || groupId !== group?.id)
    .reverse()
    .find((groupId) => {
      const hierarchyGroup = groupLookup[groupId];
      return Boolean(
        groupTypes[hierarchyGroup?.type]?.planning?.isDemandRollupTarget
      );
    });
